import getMeta from '@atlassian/jira-get-meta';

/**
 * Get current user account id from meta tag
 *
 * Inside a react component we should use useAccountId from jira-tenant-context-controller instead
 */
export const getCurrentUserAccountId = (): string | null => getMeta('ajs-atlassian-account-id');
